import React, { useEffect, useState } from "react";
import apiClient from "../../service/Axios";
import { Dialog } from "primereact/dialog";
import { toast } from "react-hot-toast";

const TeamCreateModal = ({ visible, setVisible, teamGetFuc }) => {
  const [value, setValue] = useState({
    team: "",
  });

  //team create function
  const handleTeamCreate = (e) => {
    e.preventDefault();
    apiClient
      .post(`${process.env.REACT_APP_API}/user/teams`, {
        team: value.team,
      })
      .then((res) => {
        // console.log("res", res);
        toast.success("Team create successfully");
        setValue({
          team: "",
        });
        setVisible(false);
        teamGetFuc();
      });
  };

  return (
    <div className="card flex justify-content-center">
      <Dialog
        header="Create team"
        visible={visible}
        style={{
          width: "50vw",
          background: "#fff",
          color: "black",
          padding: "20px 30px",
          marginBottom: "20px",
          boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px",
        }}
        onHide={() => setVisible(false)}>
        <form
          onSubmit={handleTeamCreate}
          className="grid grid-cols-1 gap-3 mt-10 mx-10">
          <div className="form-control">
            <label
              htmlFor="name"
              className="block text-sm font-medium leading-6 text-gray-900 mb-0.5">
              Team Name
            </label>
            <input
              required
              type="name"
              id="team"
              name="team"
              className="input input-bordered w-full rounded-[5px] h-10"
              value={value.team}
              onChange={(e) => {
                setValue((prev) => ({
                  ...prev,
                  team: e.target.value,
                }));
              }}
            />
          </div>

          <input
            className="flex w-1/4 ml-auto mt-10 justify-center rounded-[5px] bg-[#161B22] px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-[#2a5784]"
            type="submit"
            value="Create Team"
          />
        </form>
      </Dialog>
    </div>
  );
};

export default TeamCreateModal;
